<template>
  <Modal v-model="model" title="服务详情" sticky reset-drag-position @on-cancel="cancel" footer-hide fullscreen scrollable :mask="false"  class="service_customer_Info" width="1200">
    <div class="fixed_search">
      <div class="fixed_operation_btn">
        <Button class="search_btn template_btn" v-if="roleList['1_5-1']" @click="addServiceRecord('客户管理=>服务记录=>添加','1_5-1','2')">添加</Button>
        <Button class="search_btn template_btn" v-if="roleList['1_5-4']" @click="batchDelete('客户管理=>服务记录=>批量删除','1_5-4')">批量删除</Button>
      </div>
    </div>
    <div class="fixed_table">
      <Spin size="large" fix v-if="spinShow"> <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon><div>正在加载中...</div></Spin>
      <el-table :data="contentList" style="width: 100%" :height="tableHeightPop" class="element_table" :class="{'tableClass':tableClass}" stripe ref="selection" @selection-change="getSelectedId">
        <el-table-column type="selection" width="50" align="center"> </el-table-column>
        <el-table-column v-for="(item,index) in fieldList" align="center" :show-overflow-tooltip='true' :type="item.type" :key="index" :fixed="item.fixed"  :prop="item.key" :label="item.title" :width="item.width">

        <template slot="header">
            <el-tooltip  placement="top">
              <span style="overflow:hidden;text-overflow:ellipsis;white-space: nowrap;width: 100%;display: block;">{{item.title}}</span>
              <div slot="content" >
                <span>{{item.title}}</span>
              </div>
            </el-tooltip>
          </template>
        <template slot-scope="scope" >
            <!-- 附件 -->
            <el-tooltip placement="top" effect="light" v-if="item.customColSource != undefined && item.customColSource.indexOf('file') != -1 && scope.row[item.key] != '' && scope.row[item.key] != undefined">

              <span style="color: #2d8cf0;" v-show="JSON.parse(scope.row[item.key]).length > 0">共{{JSON.parse(scope.row[item.key]).length}}个附件</span>
              <div slot="content">
                <p v-for="(fileItem,fileIndex) in JSON.parse(scope.row[item.key])" :key="fileIndex">
                  <a style="font-size:14px;" :href="baseURL+'common/downloadFile.json?type=0&addr='+fileItem.downloadAddr">附件{{fileIndex+1}}：{{fileItem.description}}</a>
                </p>
              </div>
            </el-tooltip>

            <!-- 其他 -->
            <span v-else>{{scope.row[item.key]}}</span>
          </template>
        </el-table-column>



        <el-table-column  fixed="right" label="操作" width="200" v-if="contentList.length>0 && (roleList['1_5-8'] || roleList['1_5-9'])"  align="center">
          <template slot-scope="scope">
            <el-button :disabled="!scope.row.recordFile" @click="playCallRecord(scope.row.recordFile)" type="text" size="small" v-show="roleList['1_5-5-1']">播放</el-button>
            <el-button :disabled="!scope.row.recordFile" @click="downCallRecord(scope.row.recordFile)" type="text" size="small" v-show="roleList['1_5-5-2']">下载</el-button>
            <el-button v-if="roleList['1_5-6']" @click="editServiceRecord('客户管理=>服务记录=>编辑','1_5-6',scope.row.id,'2')" type="text" size="small">编辑</el-button>
            <el-button v-if="roleList['1_5-7']" @click="deleteServiceRecord('客户管理=>服务记录=>删除','1_5-7',scope.row.id)" type="text" size="small">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="page_style">
      <Page :total="total" size="small" :page-size='pageSize' :current='currentPage' :page-size-opts="pageSizeList" show-total show-sizer  @on-change="changeCurrent" @on-page-size-change="changeSize"/>
      <div style="padding-top: 2px;">跳至</div><Input class="show-elevator" v-model="speedChangePage" @on-blur="handleCurrentPage"/><div style="padding-top: 2px;">页</div>
    </div>
    <insertServiceRecordPop  @closeServiceRecord="closeServiceRecord" :lastCustomerInfo="lastCustomerInfo" :fromWhere="fromWhere" :recordTitle="recordTitle" :showEditRecord="showEditRecord" :journalType="journalType" :menuId="menuId" :formValidate="formValidate" :serviceId="serviceId"></insertServiceRecordPop>
    <publicPop @closePublicPop="closePublicPop" :pubTitle="pubTitle+'_'" :showPublicPop="showPublicPop" :popSign="pubTitle"></publicPop>
    <playMusicPop  @closeRecordfile="closeRecordfile" :showRecordFile="showRecordFile" :recordFile="recordFile"></playMusicPop>
    <a :href="musicUrl" id="downFileMusic" style="display: none">下载</a>
    <publicDialerPage  @closePublicDialerPage="closePublicDialerPage" :showPublicDialer="showPublicDialer"  :callUpPhone="callUpPhone" ></publicDialerPage>
    <PublicSendMessage  @closeSendMessage="closeSendMessage" :showSendMessage="showSendMessage"  :callUpPhone="callUpPhone" ></PublicSendMessage>
  </Modal>
</template>

<script>
    import {serviceRecordPub} from '@/components/js/ServiceRecordPub.js'
    import {publicFunClass} from '@/components/js/PublicFunClass.js'
    import {customerPublicBtn} from '@/components/js/CustomerPublicBtn.js'
    import insertServiceRecordPop from '@/components/customerMange/InsertServiceRecordPop.vue'
    import publicPop from '@/components/customerMange/PublicPop.vue'
    import playMusicPop from '@/components/statisticsReportForm/detailedReportForm/PlayMusicPop.vue'
    import publicDialerPage from '@/components/login/PublicDialerPage.vue'
    import PublicSendMessage from '@/components/login/PublicSendMessage.vue'
    export default {
      name: "ServiceDetailPop",
      mixins:[serviceRecordPub,publicFunClass,customerPublicBtn],
      components:{
        insertServiceRecordPop,
        publicPop,
        playMusicPop,
        publicDialerPage,
        PublicSendMessage
      },
      props:{
        showServiceDetail:Boolean,
        customerServiceId:String,
        customerInfo:Object
      },
      data(){
        return {
          model:false,
          showRecordFile:false,
          showEditRecord:false,
          tableHeightPop:600,
          musicUrl:'',
          recordFile:'',
          contentList: [],
          checkIds:[],
          spinShow: true,
          tableClass: true,
          selection:'',
          fieldList: [],
          searchHeight:{'height':''},
          pubTitle:'批量删除服务记录',
          showPublicPop: false,
          recordTitle:'添加服务记录',
          journalType:'',
          menuId:'',
          configInfo: JSON.parse(localStorage.getItem("configInfo")),
          roleList: JSON.parse(localStorage.getItem("roleList")),
          formValidate:{"searchList":[],"seniorList":[],"allColumnInfo":[]},
          serviceId:'',
          total: 0,
          pageSize: 20,
          currentPage: 1,
          pageSizeList: [10, 20, 30, 40, 50, 100, 200],
          speedChangePage: 1,
          fromWhere:'',
          lastCustomerInfo:{}
        }
      },
      methods:{
        //单个删除
        deleteServiceRecord:function (journalType,menuId,id) {
          let param={
            journalType:journalType,
            menuId:menuId,
            id:id
          };
          let that=this;
          this.$Modal.confirm({
            title: '提示',
            content: "是否确定删除",
            onOk: () => {
              that.$http.post("service/deleteService.json",param) .then(function (res) {
                that.spinShow=false;
                let result = res.data.flag;
                if (result != "666") {
                  that.$Modal.info({
                    title: '提示',
                    content: res.data.msg
                  });
                  return false;
                }
                that.$Message.info("删除成功");
                that.initSearch(that.customerServiceId);
              });
            }
          });
        },
        addServiceRecord:function (journalType,menuId,fromWhere) {
          this.journalType=journalType;
          this.menuId=menuId;
          this.serviceId="";
          this.lastCustomerInfo=this.customerInfo;
          this.showEditRecord=true;
          this.recordTitle="添加服务记录";
          this.fromWhere=fromWhere;
        },
        closeServiceRecord:function(flag){
          this.showEditRecord=false;
          if(flag){
            this.initSearch(this.customerServiceId);
          }
        },
        downCallRecord:function(recordFile){
          if(!recordFile){
            this.$Modal.info({
              title:'提示',
              content:"录音文件不存在"
            });
            return false;
          }
          this.musicUrl=this.baseURL+"common/downloadFile.json?type=0&addr="+recordFile;
          setTimeout(function () {
            document.getElementById("downFileMusic").click();
          },1000);
        },
        closeRecordfile:function(){
          this.showRecordFile=false;
        },
        cancel:function(){
          this.$emit("closeServiceDetail",false);
        },
        playCallRecord:function (url) {
          this.showRecordFile=true;
          this.recordFile=url;
        }
      },
      watch:{
        showServiceDetail:function () {
          this.model=this.showServiceDetail;
          if(this.showServiceDetail){
            let clientHeight=document.documentElement.clientHeight;
            this.tableHeightPop=clientHeight-132;
            this.initSearch(this.customerServiceId);
            this.handleScroll();
          }
        }
      }
    }
</script>

<style scoped>
.el-table /deep/.el-table--scrollable-x .el-table__body-wrapper{
  height: 94% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/customerMange/ServiceDetailPop.vue